import Vue from 'vue'
import Router from 'vue-router'
import { startTopProgress, settleTopProgress } from '@/utils/services/TopProgressService'
import DashboardView from '@/dashboard/views/DashboardView.vue'
import AuditListWrapperView from '@/audit/views/AuditListWrapperView.vue'
import AuditInstanceView from '@/audit/views/AuditInstanceWrapperView.vue'
import ChannelListView from '@/channel/views/ChannelListView.vue'
import ChannelSettingsListView from '@/channel/views/ChannelSettingsListView.vue'
import ChannelCredentialsWrapperView from '@/channel/views/ChannelCredentialsWrapperView.vue'
import ChannelAuthenticationStepByStepView from '@/channel/views/ChannelAuthenticationStepByStepView.vue'
import ChannelSettingsView from '@/channel/views/ChannelSettingsView.vue'
import ChannelProductListAssociationView from '@/channel/views/ChannelProductListAssociationView.vue'
import ChannelProductListAssociationLimitReqView from '@/channel/views/ChannelProductListAssociationLimitReqView.vue'
import ChannelProductListAssociationMultiView from '@/channel/views/ChannelProductListAssociationMultiView.vue'
import ChannelCategoryListAssociationView from '@/channel/views/ChannelCategoryListAssociationView.vue'
import ChannelBrandListAssociationView from '@/channel/views/ChannelBrandListAssociationView.vue'
import ChannelPaymentListAssociationView from '@/channel/views/ChannelPaymentListAssociationView.vue'
import ChannelStatusSynchronizationListView from '@/channel/views/ChannelStatusSynchronizationListView.vue'
import ChannelDeliveryCompanyListAsssociationView from '@/channel/views/ChannelDeliveryCompanyListAssociationView.vue'
import OrderListView from '@/order/views/OrderListView.vue'
import OrderView from '@/order/views/OrderView.vue'
import ProductListView from '@/product/views/ProductListView.vue'
import ProductBatchListView from '@/product/views/ProductBatchListView.vue'
import ProductListBatchStockManagementView from '@/product/views/ProductListBatchStockManagementView.vue'
import ProductListBatchStockPercentageManagementView from '@/product/views/ProductListBatchStockPercentageManagementView.vue'
import ProductListBatchPriceValueManagementView from '@/product/views/ProductListBatchPriceValueManagementView.vue'
import ProductListBatchPricePercentageManagementView from '@/product/views/ProductListBatchPricePercentageManagementView.vue'
import ProductCreationView from '@/product/views/ProductCreationView.vue'
import ProductModificationView from '@/product/views/ProductModificationView.vue'
import ProductWrapperView from '@/product/views/ProductWrapperView.vue'
import ProductImageListView from '@/product/views/ProductImageListView.vue'
import CategoryListView from '@/category/views/CategoryListView.vue'
import CategoryFormView from '@/category/views/CategoryFormView.vue'
import CategoryView from '@/category/views/CategoryView.vue'
import BrandListView from '@/brand/views/BrandListView.vue'
import BrandFormView from '@/brand/views/BrandFormView.vue'
import BrandView from '@/brand/views/BrandView.vue'
import DeliveryCompanyListView from '@/delivery_company/views/DeliveryCompanyListView.vue'
import DeliveryCompanyView from '@/delivery_company/views/DeliveryCompanyView.vue'
import PaymentListView from '@/payment/views/PaymentListView.vue'
import PaymentView from '@/payment/views/PaymentView.vue'
import StoreListView from '@/store/views/StoreListView.vue'
import SubscriberListView from '@/subscriber/views/SubscriberListView.vue'
import SubscriberBillingListView from '@/subscriber/views/SubscriberBillingListView.vue'
import SubscriberAgreementView from '@/subscriber/views/SubscriberAgreementView.vue'
import SettingsView from '@/settings/views/SettingsView.vue'
import SupportView from '@/support/views/SupportView.vue'
import SubscriberMemberListView from '@/subscriber/views/SubscriberMemberListView.vue'
import ReportListView from '@/report/views/ReportListView.vue'
import ReportFileListView from '@/report/views/ReportFileListView.vue'
import UserView from '@/user/views/UserView.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/dashboard',
    },
    {
      path: '/dashboard',
      name: 'DashboardView',
      component: DashboardView,
    },
    {
      path: '/auditorias',
      name: 'AuditListWrapperView',
      component: AuditListWrapperView,
    },
    {
      path: '/auditorias/:id',
      name: 'AuditInstanceView',
      component: AuditInstanceView,
    },
    {
      path: '/canais',
      name: 'ChannelListView',
      component: ChannelListView,
    },
    {
      path: '/canais/:id/configuracoes',
      name: 'ChannelSettingsListView',
      component: ChannelSettingsListView,
    },
    {
      path: '/canais/:id/configuracoes/credenciais',
      name: 'ChannelCredentialsView',
      component: ChannelCredentialsWrapperView,
    },
    {
      path: '/canais/:id/configuracoes/autenticacao-passo-a-passo',
      name: 'ChannelAuthenticationStepByStepView',
      component: ChannelAuthenticationStepByStepView,
    },
    {
      path: '/canais/:id/configuracoes/estoque-precos-e-mais',
      name: 'ChannelSettingsView',
      component: ChannelSettingsView
    },
    {
      path: '/canais/:id/configuracoes/associacoes/produtos',
      name: 'ChannelProductListAssociationView',
      component: ChannelProductListAssociationView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/limit_req/produtos',
      name: 'ChannelProductListAssociationLimitReqView',
      component: ChannelProductListAssociationLimitReqView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/multi/produtos',
      name: 'ChannelProductListAssociationMultiView',
      component: ChannelProductListAssociationMultiView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/categorias',
      name: 'ChannelCategoryListAssociationView',
      component: ChannelCategoryListAssociationView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/marcas',
      name: 'ChannelBrandListAssociationView',
      component: ChannelBrandListAssociationView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/formas_pagamento',
      name: 'ChannelPaymentListAssociationView',
      component: ChannelPaymentListAssociationView,
    },
    {
      path: '/canais/:id/configuracoes/associacoes/transportadoras',
      name: 'ChannelDeliveryCompanyListAssociationView',
      component: ChannelDeliveryCompanyListAsssociationView,
    },
    {
      path: '/canais/:id/configuracoes/informacoes/fila-processamento',
      name: 'ChannelStatusSynchronizationListView',
      component: ChannelStatusSynchronizationListView,
    },
    {
      path: '/pedidos',
      name: 'OrderListView',
      component: OrderListView,
    },
    {
      path: '/pedidos/:id',
      name: 'OrderView',
      component: OrderView,
    },
    {
      path: '/produtos',
      name: 'ProductListView',
      component: ProductListView,
    },
    {
      path: '/produtos/lotes',
      name: 'ProductBatchListView',
      component: ProductBatchListView,
    },
    {
      path: '/produtos/lotes/:id/gerenciamento_estoque_por_loja_em_lote',
      name: 'ProductListBatchStockManagementView',
      component: ProductListBatchStockManagementView,
    },
    {
      path: '/produtos/lotes/:id/gerenciamento_porcentagem_estoque_por_canal_em_lote',
      name: 'ProductListBatchStockPercentageManagementView',
      component: ProductListBatchStockPercentageManagementView,
    },
    {
      path: '/produtos/lotes/:id/gerenciamento_preco_fixo_por_canal_em_lote',
      name: 'ProductListBatchPriceValueManagementView',
      component: ProductListBatchPriceValueManagementView,
    },
    {
      path: '/produtos/lotes/:id/gerenciamento_preco_calculado_por_canal_em_lote',
      name: 'ProductListBatchPricePercentageManagementView',
      component: ProductListBatchPricePercentageManagementView,
    },
    {
      path: '/produtos/novo',
      name: 'ProductCreationView',
      component: ProductCreationView,
    },
    {
      path: '/produtos/:id/edicao',
      name: 'ProductModificationView',
      component: ProductModificationView,
    },
    {
      path: '/produtos/:id',
      name: 'ProductWrapperView',
      component: ProductWrapperView,
    },
    {
      path: '/imagens',
      name: 'ProductImageListView',
      component: ProductImageListView,
    },
    {
      path: '/categorias',
      name: 'CategoryListView',
      component: CategoryListView,
    },
    {
      path: '/categorias/nova',
      name: 'CategoryFormView',
      component: CategoryFormView,
    },
    {
      path: '/categorias/:id/edicao',
      name: 'CategoryFormView',
      component: CategoryFormView,      
    },
    {
      path: '/categorias/:id',
      name: 'CategoryView',
      component: CategoryView,
    },
    {
      path: '/marcas',
      name: 'BrandListView',
      component: BrandListView,
    },
    {
      path: '/marcas/nova',
      name: 'BrandFormView',
      component: BrandFormView,
    },
    {
      path: '/marcas/:id/edicao',
      name: 'BrandFormView',
      component: BrandFormView,
    },
    {
      path: '/marcas/:id',
      name: 'BrandView',
      component: BrandView,
    },
    {
      path: '/transportadoras',
      name: 'DeliveryCompanyListView',
      component: DeliveryCompanyListView,
    },
    {
      path: '/transportadoras/:id',
      name: 'DeliveryCompanyView',
      component: DeliveryCompanyView,
    },
    {
      path: '/formas_pagamento',
      name: 'PaymentListView',
      component: PaymentListView,
    },
    {
      path: '/formas_pagamento/:id',
      name: 'PaymentView',
      component: PaymentView,
    },
    {
      path: '/lojas',
      name: 'StoreListView',
      component: StoreListView,
    },
    {
      path: '/empresas',
      name: 'SubscriberListView',
      component: SubscriberListView,
    },
    {
      path: '/contrato',
      name: 'SubscriberAgreementView',
      component: SubscriberAgreementView,
    },
    {
      path: '/configuracoes',
      name: 'SettingsView',
      component: SettingsView,
    },
    {
      path: '/configuracoes/membros',
      name: 'SubscriberMemberListView',
      component: SubscriberMemberListView,
    },
    {
      path: '/atendimento',
      name: 'SupportView',
      component: SupportView,
    },
    {
      path: '/atendimento/faturamento',
      name: 'SubscriberBillingListView',
      component: SubscriberBillingListView,
    },
    {
      path: '/relatorios',
      name: 'ReportListView',
      component: ReportListView,
    },
    {
      path: '/relatorios/:id/arquivos',
      name: 'ReportFileListView',
      component: ReportFileListView,
    },
    {
      path: '/usuarios/meus_dados',
      name: 'UserView',
      component: UserView,
    },
  ],
});

// barra de progresso no topo; mudancas so de query (filtros, paginacao) nao disparam.
// a primeira navegacao fica de fora porque o splash ja cobre o carregamento inicial
router.beforeEach((to, from, next) => {
  const isInitialNavigation = !from.matched.length

  if (!isInitialNavigation && to.path !== from.path) {
    startTopProgress()
  }

  next()
})

router.afterEach(() => {
  settleTopProgress()
})

export default router
